import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import ScreenfullComponent from '@/components/Screenfull'

const app = createApp(App)

app.use(router)
app.use(ElementPlus)
app.component('ScreenfullComponent', ScreenfullComponent)

app.mount('#app')

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const secure =
      window.isSecureContext ||
      location.hostname === 'localhost' ||
      location.hostname === '127.0.0.1'
    if (!secure) return
    const baseUrl = process.env.BASE_URL || '/'
    navigator.serviceWorker.register(`${baseUrl}service-worker.js`, { scope: baseUrl }).catch(() => {})
  })
}
